import Api from "../services/AxiosService";
import { unwrap } from "./envelope";

// svc-04 `/v1/admin/calculation-parameters` (gateway routes /v1/admin/* to
// admin-config). Read surface behind the "Calculation Parameters" dataset
// page: assembled from cost_model_global_defaults (Globals) +
// cost_model_constants (per cost model).
//
// Types mirror @penn/shared-types CalculationParameter (kept local per the
// existing api/*.ts convention).

export interface CalculationParameter {
  id: string;
  label: string;
  group: string;
  value: string;
  unit: string;
  note: string;
  /** JSON string, e.g. {"kind":"global","key":...} or {"kind":"model",...}. */
  binding: string;
}

export interface CalculationParameterList {
  data: CalculationParameter[];
  total: number;
}

/** Edit payload. `value` required (numeric string); `unit`/`note` apply to
 *  Globals only (ignored server-side for per-model constants). */
export interface UpdateCalculationParameterBody {
  value: string;
  unit?: string;
  note?: string;
}

const BASE = "/v1/admin/calculation-parameters";

/** GET /v1/admin/calculation-parameters — Globals + per-cost-model params. */
export async function listCalculationParameters(): Promise<CalculationParameterList> {
  const res = await Api.get(BASE);
  return unwrap<CalculationParameterList>(res.data);
}

/** PATCH /v1/admin/calculation-parameters/:id — edit one parameter.
 *  `id` is `global.<key>` or `<modelId>.<constantKey>`. Requires
 *  `canManageMasterData`. Returns the re-read record. */
export async function updateCalculationParameter(
  id: string,
  body: UpdateCalculationParameterBody,
): Promise<CalculationParameter> {
  const res = await Api.patch(`${BASE}/${encodeURIComponent(id)}`, body);
  return unwrap<CalculationParameter>(res.data);
}
